// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-283f2785] .v-text-field__slot {\n  max-width: 100%;\n}", ""]);
// Exports
module.exports = exports;
